const ArrowForward = props => (
  <svg viewBox="0 0 6 10" {...props}>
    <path d="M.81 10a.74.74 0 0 0 .55-.23l4.38-4.29A.89.89 0 0 0 6 4.84a.84.84 0 0 0-.28-.63l-4.38-4A.77.77 0 0 0 .2.3a.88.88 0 0 0 .08 1.2L4 4.88.26 8.52a.88.88 0 0 0 0 1.21.78.78 0 0 0 .55.27" />
  </svg>
);

export default ArrowForward;
